import React from "react";

const ChargeError = () => {
  return <div>ChargeError</div>;
};

export default ChargeError;
